import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './ImageGallery.css';

const ImageGallery = ({ data, showMaximumChat, setIsShowMaximumChat }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  useEffect(() => {
    if (isModalOpen) {
      const handleKeyDown = (event) => {
        if (event.key === 'ArrowRight') nextImage();
        if (event.key === 'ArrowLeft') prevImage();
        if (event.key === 'Escape') closeModal();
      };
      window.addEventListener('keydown', handleKeyDown);
      return () => window.removeEventListener('keydown', handleKeyDown);
    }
  }, [isModalOpen]);

  const openModal = (index) => {
    setCurrentImageIndex(index);
    setIsModalOpen(true);
  };

  const closeModal = () => setIsModalOpen(false);

  const nextImage = () => setCurrentImageIndex((prev) => (prev + 1) % data.length);

  const prevImage = () => setCurrentImageIndex((prev) => (prev - 1 + data.length) % data.length);

  return (
    <div
      onClick={() => !showMaximumChat && setIsShowMaximumChat(!showMaximumChat)}
      className="image-gallery"
    >
      <div className="image-grid">
        {data.map((image, index) => (
          <div
            className="image-container"
            key={index}
            onClick={() => openModal(index)}
          >
            <img style={{ borderRadius: '10px' }} src={image?.link} alt={image?.caption} />
            <p>{image?.caption}</p>
          </div>
        ))}
      </div>

      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeModal}
        className="modal"
        overlayClassName="overlay"
      >
        <div className="modal-content">
          <button className="close-button" onClick={closeModal}>
            ×
          </button>
          <img
            style={{ borderRadius: '10px' }}
            src={data[currentImageIndex].link}
            alt={data[currentImageIndex].caption}
          />
          <p>{data[currentImageIndex].caption}</p>
          <button className="prev-button" onClick={prevImage}>
            ‹
          </button>
          <button className="next-button" onClick={nextImage}>
            ›
          </button>
        </div>
      </Modal>
    </div>
  );
};

export default ImageGallery;
